import * as amplitude from '@amplitude/analytics-browser';

const CROSS_DOMAIN_VALIDITY_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Appends Amplitude cross-domain tracking params (ampDeviceId, ampSessionId,
 * ampTimestamp) to a redirect URL so the SDK on the destination page can
 * maintain the same user identity and session.
 *
 * @see https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2#cross-domain-tracking
 */
export function appendAmplitudeCrossDomainParams(redirectUrl: string): string {
  if (typeof window === 'undefined') return redirectUrl;

  const deviceId = amplitude.getDeviceId();
  const sessionId = amplitude.getSessionId();

  if (!deviceId && !sessionId) return redirectUrl;

  try {
    const resolved = new URL(redirectUrl, window.location.origin);

    if (deviceId) {
      resolved.searchParams.set('ampDeviceId', deviceId);
    }
    if (sessionId != null) {
      resolved.searchParams.set('ampSessionId', String(sessionId));
    }
    resolved.searchParams.set(
      'ampTimestamp',
      String(Date.now() + CROSS_DOMAIN_VALIDITY_MS)
    );

    if (/^https?:\/\//i.test(redirectUrl)) {
      return resolved.toString();
    }

    return `${resolved.pathname}${resolved.search}${resolved.hash}`;
  } catch {
    return redirectUrl;
  }
}
